import React, { useMemo } from "react";
import { Node } from "@tiptap/core";
import { NodeViewWrapper, NodeViewContent } from "@tiptap/react";
import { ReactNodeViewRenderer } from "@tiptap/react";

const ToolResponse = React.memo(({ node }) => {
  const { query, toolResponse } = node.attrs;

  const renderedContent = useMemo(() => {
    return (
      <div>
        <h3>{query}</h3>
        <div className="mt-2">{toolResponse}</div>
        <NodeViewContent>{toolResponse}</NodeViewContent>
      </div>
    );
  }, [query, toolResponse]);

  return <NodeViewWrapper as="div">{renderedContent}</NodeViewWrapper>;
});

const ToolResponseNode = Node.create({
  name: "toolResponse",

  group: "block",

  content: "inline*",

  draggable: false,

  addAttributes() {
    return {
      query: {
        default: "",
      },
      toolResponse: {
        default: "",
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "tool-response",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["tool-response", HTMLAttributes];
  },

  addNodeView() {
    return ReactNodeViewRenderer(ToolResponse);
  },
});

export default ToolResponseNode;
